import { AfterContentInit, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppareilMesure } from 'src/app/domain/appareil-meure';
import { AppareilMesureService } from 'src/app/services/appareil-mesure.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';

@Component({
    selector: 'app-appareil-mesure',
    templateUrl: './appareil-mesure.component.html',
    styleUrls: ['./appareil-mesure.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppareilMesureComponent implements OnInit, AfterContentInit {

    Model: AppareilMesure = new AppareilMesure();

    constructor(
        private snackBar: MatSnackBar,
        private appareilMesureService: AppareilMesureService,
        private coreData: CoreData) { }

    ngOnInit(): void {
        this.coreData.CurrentPageName = "Appareil de mesure";
    }

    ngAfterContentInit() {
        this.appareilMesureService.getMyDevicesInfo().subscribe(x => {
            this.Model = x;
        })
    }

    save() {
        this.appareilMesureService.setMyDevicesInfo(this.Model).subscribe((x: boolean) => {
            if (x) {
                NotificationManager.handleSuccess('Paramètres enregistrés' , this.snackBar);
            }
        })
    }
}
